const logLevels = {
  NONE: 'NONE',
  NOTICE: 'NOTICE',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  ALL: 'ALL',
};

export default logLevels;



// WEBPACK FOOTER //
// ./resources/assets/js/components/logger/logLevels.js